import { styled } from 'styled-components';

export const WhatsNewModalWrapper = styled.div`
  dialog {
    max-width: 671px;
  }
`;
WhatsNewModalWrapper.displayName = 'WhatsNewModalWrapper';

export const WhatsNewModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .buttons {
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
`;
WhatsNewModalHeader.displayName = 'WhatsNewModalHeader';

export const WhatsNewModalBody = styled.div`
  > *:nth-child(1),
  > *:nth-child(2),
  > *:nth-child(5) {
    margin-bottom: ${({ theme }) => theme.sizing.medium};
  }

  > *:nth-child(3),
  > *:nth-child(4) {
    margin-bottom: ${({ theme }) => theme.sizing.small};
  }

  ol {
    list-style: decimal;
    padding-left: ${({ theme }) => theme.sizing.large};

    li {
      ${({ theme }) => theme.typography.bodyRegular}
      padding-left: ${({ theme }) => theme.sizing.small};
    }
  }

  ul {
    list-style: disc;
    padding-left: ${({ theme }) => theme.sizing.large};
    margin-left: ${({ theme }) => theme.sizing.large};
    margin-top: ${({ theme }) => theme.sizing.small};
    margin-bottom: ${({ theme }) => theme.sizing.large};

    li {
      ${({ theme }) => theme.typography.bodyRegular}
      padding-left: ${({ theme }) => theme.sizing.small};
      margin-bottom: ${({ theme }) => theme.sizing.small};
    }
  }
`;
WhatsNewModalBody.displayName = 'WhatsNewModalBody';
